import { Component, Input, OnInit, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { MultipleFilterProperty } from '../../_model/multiple-filter-property';
import { TableFilters } from '../../_model/table-response/table-filters';
import { CommonModule, DatePipe } from '@angular/common';
import { Constants } from '../../_model/constants';
import { Observable, Subscription } from 'rxjs';
import { ClientStateService } from '../navbar/client-state.service';
import { LoginStateService } from "../../pages/login/login-state.service";
import { SnackbarService } from '../../service/snackbar.service';
import { environment } from '../../../environments/environment';
import { map, startWith } from 'rxjs/operators';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';

@Component({
  selector: 'app-stores-multiple-input-filter',
  templateUrl: './stores-multiple-input-filter.component.html',
  standalone: true,
  imports: [MatChipsModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatOptionModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    CommonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatDialogModule,
    MatTabsModule,
    MatToolbarModule,
    MatListModule,
    MatSidenavModule,
    MatExpansionModule,
    MatSnackBarModule,
    MatGridListModule,
    MatCheckboxModule,
    MatRadioModule,
  ],
  styleUrls: ['./stores-multiple-input-filter.component.scss']
})


export class StoresMultipleInputFilterComponent implements OnInit {

  @Input() tableFilters!: TableFilters[];
  @Output() selectedFilter = new EventEmitter<FormGroup>();

  clientSubscription!: Subscription;

  localTableFilters!: TableFilters[];
  filterForms!: FormGroup;
  todayDate!: Date;


  filterArray: Array<MultipleFilterProperty> = [];
  dateFilterSelected = false;
  filterApplied = false;
  removable = true;
  filterAdded = false;
  dateFilterAdded = false;
  excelClicked = false;
  isAddCliecked = false;
  searchClicked = false;
  isLoadingResults = false;
  isVisits = false;
  selected: any;
  filterArrayForms!: FormGroup;
  visitFlag = false;
  workOrderFlag = false;
  start_date: any;
  end_date: any;
  workOrders: string[] = [
    'CORRECTIVE',
    'MAINTENANCE'];
  filteredOptions!: Observable<any[]>;
  value = new FormControl('');

  constructor(private fb: FormBuilder,
    public datepipe: DatePipe,
    private clientStateService: ClientStateService, private loginStateService: LoginStateService,
    private sbService: SnackbarService, private cdRef: ChangeDetectorRef) {
    this.initializeFilter();
  }

  public beComponentForm: FormGroup = new FormGroup({
    value: new FormControl("")
  });

  ngOnInit() {
    this.localTableFilters = this.tableFilters;
    this.clientSubscription = this.clientStateService.clientStateChanged$.subscribe(() => {
      this.initializeFilter();
      this.filterApplied = false;
      this.dateFilterSelected = false;
      this.filterAdded = false;
      this.dateFilterAdded = false;
      this.visitFlag = false;
      this.workOrderFlag = false;
      this.filterArray = [];
    });
    if (this.loginStateService.isVisits == true) {
      // this.visitFilter();
      this.visitFlag = true;
      this.loginStateService.isVisits = false;
    }
    else if (this.loginStateService.isWorkOrders == true) {
      this.workOrderFlag = true;
      this.loginStateService.isWorkOrders = false;
    }
    else {
      this.visitFlag = false;
      this.workOrderFlag = false;
      this.loginStateService.isVisits = false;
      this.loginStateService.isWorkOrders = false;
      this.removeItem();
    }
    this.filteredOptions = this.value.valueChanges
      .pipe(
        startWith<string | TableFilters | null>(''),
        map(value => typeof value === 'string' ? value : value),
        map(value => {
          if (typeof value === 'string') {
            return this.filterForms.value.tableFilter.values.filter(
              (option: string) => option.toLowerCase().includes(value.toLowerCase())
            );
          }
          // Handle the case where value is not a string
          return this.filterForms.value.tableFilter.values;
        })
      );
  }


  removeItem() {
    // JSON.parse(localStorage.getItem('setFilter')) || 
    if (this.visitFlag) {
      // localStorage.removeItem('setFilter');
      this.loginStateService.isVisits = false;
      this.visitFlag = false;
    }
    else if (this.workOrderFlag) {
      this.loginStateService.isWorkOrders = false;
      this.workOrderFlag = false;
    }
  }

  lookup(name: string): TableFilters[] {
    const filterValue = name.toLowerCase();
    return this.filterForms.value.tableFilter.values.filter((option: string) => option.toLowerCase().includes(filterValue));

  }

  clean(t: any) {
    t.value = '';
    this.lookup(t.value);
  }

  private _filter(name: string): TableFilters[] {
    const filterValue = name.toLowerCase();
    return this.filterForms.value.tableFilter.values.filter((option: string) => option.toLowerCase().includes(filterValue));
  }

  open(evt: any) {
    this.filteredOptions = this.value.valueChanges
      .pipe(
        startWith(''),
        map(value => {
          // Handle null/undefined values and return them, so the next map can handle them.
          if (value === null || value === undefined) {
            return null;
          }
          // Correctly handle the value based on its type.
          // If it's a string, return the string. Otherwise, assume it's the object with a 'values' property.
          // The ternary operator is now inside this check.
          return typeof value === 'string' ? value : (value as any).values;
        }),
        // The second map now correctly handles the possibility of a 'null' value.
        map(value => {
          if (value === null) {
            return []; // Or some other empty array
          }
          return this._filter(value);
        })
      );
  }


  checkAndCallMethods() {
    if (this.isAddCliecked) {
      this.addFilter();
    } else if (this.searchClicked) {
      const multipleFilterArrayControl = this.filterForms.get('multipleFilterarray');
      if (this.filterArray.length > 0 && multipleFilterArrayControl) {
        multipleFilterArrayControl.setValue(this.filterArray);
      }
      this.selectedFilter.emit(this.filterForms);
    } else if (this.excelClicked) {
      const multipleFilterArrayControl = this.filterForms.get('multipleFilterarray');
      if (this.filterArray.length > 0 && multipleFilterArrayControl) {
        multipleFilterArrayControl.setValue(this.filterArray);
      }
      this.getDatatoExcel(this.filterForms);
    }
  }

  addFilter() {
    let multipleFilterProperty = new MultipleFilterProperty();
    let isDuplicate = false;
    for (let item of this.filterArray) {

      if (item.value === this.filterForms.value.value) {
        isDuplicate = true;
        break;
      }
    }
    let existItem = this.filterArray.filter(item => item.dispalyName === this.filterForms.value.tableFilter.displayName);
    if (!isDuplicate && (existItem.length < 1 || (existItem.length >= 0 && this.filterForms.value.tableFilter.displayName == Constants.status))) {
      if (this.filterForms.value.tableFilter.displayName == Constants.date) {
        let existDateItem = this.filterArray.filter(item => item.dateValue === this.filterForms.value.tableFilter.displayName);
        if (existDateItem.length < 1) {
          multipleFilterProperty.dispalyName = this.filterForms.value.tableFilter.displayName;
          multipleFilterProperty.column = this.filterForms.value.tableFilter.column;
          multipleFilterProperty.dateValue = this.filterForms.value.tableFilter.displayName;
          multipleFilterProperty.dateBackendName = this.filterForms.value.value
          multipleFilterProperty.origionalStartDateFormat = this.filterForms.value.valuedate.begin;
          multipleFilterProperty.origionalEndDateFormat = this.filterForms.value.valuedate.end;
          if (environment.locale == "en-GB") {
            this.start_date = this.datepipe.transform(this.filterForms.value.valuedate.begin, Constants.dateFormatEngb);
            this.end_date = this.datepipe.transform(this.filterForms.value.valuedate.end, Constants.dateFormatEngb);
          }
          else if (environment.locale == "en-US") {
            this.start_date = this.datepipe.transform(this.filterForms.value.valuedate.begin, Constants.dateFormaten029);
            this.end_date = this.datepipe.transform(this.filterForms.value.valuedate.end, Constants.dateFormaten029);
          }
          multipleFilterProperty.value = this.start_date + " - " + this.end_date;
          this.filterArray.push(multipleFilterProperty);
          this.dateFilterAdded = true;
        } else {
          alert(Constants.dateErrorAlert);
        }

      } else {
        multipleFilterProperty.dispalyName = this.filterForms.value.tableFilter.displayName;
        multipleFilterProperty.column = this.filterForms.value.tableFilter.column;
        multipleFilterProperty.value = this.filterForms.value.value;
        this.filterArray.push(multipleFilterProperty);
      }
    } else {
      alert(Constants.duplicateFilterAlert);
    }
    this.filterApplied = true;
    this.initializeFilter();
    this.dateFilterSelected = false;
    this.filterAdded = true;
  }


  changeValue(event: MatSelectChange<any>) {
    const filter = event.value;
    this.filterForms.get('value')?.reset('');
    this.filterForms.get('valuedate')?.reset({ start: '', end: '' });
    if ((filter?.displayName === 'Date' || filter?.displayName === Constants.date) && filter?.values?.length === 1) {
      this.filterForms.get('value')?.setValue(filter.values[0]);
    }
    if (filter.displayName === Constants.date) {
      this.dateFilterSelected = true;
      if (filter.displayName == Constants.scheduledStartDate) {
        this.todayDate = new Date(Constants.scheduledStartActiveDate);
      } else {
        this.todayDate = new Date("");
      }
    }
    else {
      this.dateFilterSelected = false;
    }
  }

  private initializeFilter() {
    this.filterForms = this.fb.group({
      tableFilter: '',
      value: '',
      valuedate: '',
      multipleFilterarray: []
    });
  }

  remove(value: string): void {
    const index = this.filterArray.map(e => e.value).indexOf(value);
    if (index >= 0) {
      this.filterArray.splice(index, 1);
    }

    const dateIndex = this.filterArray.map(e => e.dateValue).indexOf(Constants.date);
    if (dateIndex <= -1) {
      this.dateFilterAdded = false;
    }

    if (this.filterArray.length == 0) {
      this.filterAdded = false;
      this.selectedFilter.emit(this.filterForms);
    }
  }

  isArray = () => this.filterForms.value.tableFilter.values && this.filterForms.value.tableFilter.values.length;
  // isArray = () => this.filterForms.value.tableFilter.values && this.filterForms.value.tableFilter.values.length;

  isFilterSet = () => {
    if (((this.filterForms.value.tableFilter.displayName == Constants.backOfficeId && this.filterForms.value.value) ||
      (this.filterForms.value.tableFilter.displayName == Constants.fmStoreId && this.filterForms.value.value) ||
      (this.filterForms.value.tableFilter.displayName == Constants.address && this.filterForms.value.value) ||
      (this.filterForms.value.tableFilter.displayName == Constants.postCode && this.filterForms.value.value))) {
      return true;
    }
    else if (this.filterForms.value.value) {
      return true;
    }
    return false;
  }


  isWONumberFilterApplied = () => {
    if ((this.filterForms.value.tableFilter.displayName == Constants.backOfficeId ||
      this.filterForms.value.tableFilter.displayName == Constants.fmStoreId ||
      this.filterForms.value.tableFilter.displayName == Constants.address ||
      this.filterForms.value.tableFilter.displayName == Constants.postCode)) {
      return true;
    }
    else if ((this.filterForms.value.tableFilter.displayName == Constants.accountNumber || this.filterForms.value.tableFilter.displayName == Constants.contractNumber)) {
      return false;
    }
    else if (this.filterForms.value.value) {
      return true;
    }
    else if (this.filterArray.length > 1) {
      return true;
    }
    else if (this.filterForms.value.tableFilter) {
      return false;
    } else {
      return false;
    }
  };

  isAnyFilterSet = () => {
    if (this.filterArray.length > 1 || this.filterForms.value.value) {
      return true;
    }
    else {
      return false;
    }
  }

  isExcelClicked() {
    this.excelClicked = true;
    this.searchClicked = false;
    this.isAddCliecked = false;
  }

  isSearchClicked() {
    this.searchClicked = true;
    this.excelClicked = false;
    this.isAddCliecked = false;
  }

  isAddFilterCliecked() {
    this.isAddCliecked = true;
  }

  reset() {
    this.initializeFilter();
    this.selectedFilter.emit(this.filterForms);
    this.filterApplied = false;
    this.dateFilterSelected = false;
    this.filterAdded = false;
    this.dateFilterAdded = false;
    this.filterArray = [];
    this.removeItem();
  }

  private getDatatoExcel(formValues: FormGroup) {
    this.isLoadingResults = true;

  }

}
